import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { normalizeAngle } from "../shared/utils";

export default class Cursor extends AbstractProvidedClass {
    set(curs) {
        this.p.cursor(curs);
    }

    arrow() {
        this.p.cursor(this.p.ARROW);
    }

    cross() {
        this.p.cursor(this.p.CROSS);
    }

    delete() {
        this.p.cursor('not-allowed');
    }

    grab() {
        this.p.cursor('grab');
    }

    grabbing() {
        this.p.cursor('grabbing');
    }

    pointer() {
        this.p.cursor('pointer');
    }

    resizeHorizontal(angle = 0) {
        this.resizeAngle(angle);
    }

    resizeNESW(angle = 0) {
        this.resizeAngle(angle - Math.PI / 4);
    }

    resizeNWSE(angle = 0) {
        this.resizeAngle(angle + Math.PI / 4);
    }

    resizeVertical(angle = 0) {
        this.resizeAngle(angle + Math.PI / 2);
    }

    move() {
        this.p.cursor('move');
    }

    resizeAngle(angle) {
        angle = normalizeAngle(angle);
        if (angle < -(7 / 8) * Math.PI || angle > (7 / 8) * Math.PI) {
            this.p.cursor('ew-resize'); // horizontal
        } else if (angle < -(5 / 8) * Math.PI) {
            this.p.cursor('nwse-resize');
        } else if (angle < -(3 / 8) * Math.PI) {
            this.p.cursor('ns-resize'); // vertical
        } else if (angle < -(1 / 8) * Math.PI) {
            this.p.cursor('nesw-resize');
        } else if (angle < (1 / 8) * Math.PI) {
            this.p.cursor('ew-resize'); // horizontal
        } else if (angle < (3 / 8) * Math.PI) {
            this.p.cursor('nwse-resize');
        } else if (angle < (5 / 8) * Math.PI) {
            this.p.cursor('ns-resize'); // vertical
        } else {
            this.p.cursor('nesw-resize');
        }
    }
}
